export interface IGetVisibleRegionPillLabelsParams {
    availableWidth: number;
    gap: number;
    regionLabels: string[];
    regionPillWidths: number[];
    counterPillWidths: Record<number, number>;
}

export const getCompactRegionPillLabels = (regionLabels: string[]): string[] => {
    if (regionLabels.length <= 2) {
        return regionLabels;
    }

    return [regionLabels[0], `+${(regionLabels.length - 1).toString()}`];
};

export const getVisibleRegionPillLabels = (params: IGetVisibleRegionPillLabelsParams): string[] => {
    const {availableWidth, counterPillWidths, gap, regionLabels, regionPillWidths} = params;

    if (regionLabels.length <= 1 || availableWidth <= 0 || regionPillWidths.length < regionLabels.length) {
        return getCompactRegionPillLabels(regionLabels);
    }

    if (arePillsFitting(regionPillWidths, availableWidth, gap)) {
        return regionLabels;
    }

    for (let visibleRegionCount = regionLabels.length - 1; visibleRegionCount >= 1; visibleRegionCount--) {
        const hiddenRegionCount = regionLabels.length - visibleRegionCount;
        const counterPillWidth = counterPillWidths[hiddenRegionCount];

        if (typeof counterPillWidth !== "number") {
            continue;
        }

        const visiblePillWidths = [...regionPillWidths.slice(0, visibleRegionCount), counterPillWidth];

        if (arePillsFitting(visiblePillWidths, availableWidth, gap)) {
            return [...regionLabels.slice(0, visibleRegionCount), `+${hiddenRegionCount.toString()}`];
        }
    }

    return [regionLabels[0], `+${(regionLabels.length - 1).toString()}`];
};

const arePillsFitting = (pillWidths: number[], availableWidth: number, gap: number) => {
    const gapsWidth = Math.max(0, pillWidths.length - 1) * gap;
    const pillsWidth = pillWidths.reduce((sum, width) => sum + width, 0);

    return pillsWidth + gapsWidth <= availableWidth;
};
export interface IGetVisibleRegionPillLabelsParams {
    availableWidth: number;
    gap: number;
    regionLabels: string[];
    regionPillWidths: number[];
    counterPillWidths: Record<number, number>;
}

export const getCompactRegionPillLabels = (regionLabels: string[]): string[] => {
    if (regionLabels.length <= 2) {
        return regionLabels;
    }

    return [regionLabels[0], `+${(regionLabels.length - 1).toString()}`];
};

export const getVisibleRegionPillLabels = (params: IGetVisibleRegionPillLabelsParams): string[] => {
    const {availableWidth, counterPillWidths, gap, regionLabels, regionPillWidths} = params;

    if (regionLabels.length <= 1 || availableWidth <= 0 || regionPillWidths.length < regionLabels.length) {
        return getCompactRegionPillLabels(regionLabels);
    }

    if (arePillsFitting(regionPillWidths, availableWidth, gap)) {
        return regionLabels;
    }

    for (let visibleRegionCount = regionLabels.length - 1; visibleRegionCount >= 1; visibleRegionCount--) {
        const hiddenRegionCount = regionLabels.length - visibleRegionCount;
        const counterPillWidth = counterPillWidths[hiddenRegionCount];

        if (typeof counterPillWidth !== "number") {
            continue;
        }

        const visiblePillWidths = [...regionPillWidths.slice(0, visibleRegionCount), counterPillWidth];

        if (arePillsFitting(visiblePillWidths, availableWidth, gap)) {
            return [...regionLabels.slice(0, visibleRegionCount), `+${hiddenRegionCount.toString()}`];
        }
    }

    return [regionLabels[0], `+${(regionLabels.length - 1).toString()}`];
};

const arePillsFitting = (pillWidths: number[], availableWidth: number, gap: number) => {
    const gapsWidth = Math.max(0, pillWidths.length - 1) * gap;
    const pillsWidth = pillWidths.reduce((sum, width) => sum + width, 0);

    return pillsWidth + gapsWidth <= availableWidth;
};
